<template>
  <v-container fluid class="customer-home-page pa-0">
    <div v-if="!$vuetify.breakpoint.xsOnly" class="customer-split-shell">
      <splitpanes class="default-theme customer-split">
        <pane min-size="30" size="35" max-size="50">
          <div class="customer-list-pane">
            <CustomerMiniList />
          </div>
        </pane>

        <pane>
          <div class="customer-profile-pane">
            <div v-if="!getCustomer" class="empty-customer-state">
              <lottie
                :height="220"
                :width="220"
                :options="defaultOptions"
                v-on:animCreated="handleAnimation"
              />

              <div class="empty-title">No customer selected</div>
              <div class="empty-subtitle">
                Select a customer from the list to view details.
              </div>
            </div>

            <Profile v-else :key="getCustomer.id" />
          </div>
        </pane>
      </splitpanes>
    </div>

    <div v-else class="mobile-customer-list">
      <CustomerList />
    </div>
  </v-container>
</template>

<script>
import CustomerList from "../components/List";
import CustomerMiniList from "../components/MiniList";
import Lottie from "@/components/lottie.vue";
import * as animationData from "@/assets/lottie/empty_list.json";
import Profile from "./Profile";
import { mapGetters } from "vuex";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

export default {
  name: "customer-home",

  components: {
    CustomerList,
    CustomerMiniList,
    Profile,
    Splitpanes,
    Pane,
    Lottie,
  },

  data() {
    return {
      defaultOptions: {
        loop: true,
        autoplay: true,
        animationData: animationData.default,
      },
    };
  },

  computed: {
    ...mapGetters("customer", ["getCustomer"]),
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },

  methods: {
    handleAnimation(anim) {
      this.anim = anim;
    },
  },
};
</script>

<style scoped>
.customer-home-page {
  width: 100%;
  height: 100%;
  min-height: 0;
}

.customer-split-shell {
  height: calc(100vh - 132px);
  min-height: 0;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  overflow: hidden;
}

.customer-split {
  height: 100%;
  min-height: 0;
}

.customer-list-pane,
.customer-profile-pane {
  height: 100%;
  min-height: 0;
  background: #ffffff;
}

.customer-list-pane {
  overflow: hidden;
  border-right: 1px solid #e2e8f0;
}

.customer-profile-pane {
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
}

.empty-customer-state {
  height: 100%;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  padding: 32px;
  background: #ffffff;
}

.empty-title {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
  margin-top: 8px;
}

.empty-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 4px;
}

.mobile-customer-list {
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  overflow: hidden;
  background: #ffffff;
}

::v-deep .splitpanes__splitter {
  width: 10px !important;
  background: #f8fafc !important;
  border-left: 1px solid #e2e8f0;
  border-right: 1px solid #e2e8f0;
}

::v-deep .splitpanes__splitter:hover {
  background: #eef2ff !important;
}

@media (max-width: 600px) {
  .customer-split-shell {
    height: auto;
    min-height: auto;
  }

  .mobile-customer-list {
    border-radius: 16px;
  }
}
</style>
